/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Spinner } from "reactstrap";

const OverlaySpinner = ({show = false, color = "success", style = {}}) => {
  // spinner overlay style
  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#00000000",
    cursor: "wait",
    zIndex: 10,
    ...style
  };

  return show ? (
    <div style={overlayStyle}>
      <Spinner color={color} style={{ width: '3rem', height: '3rem' }} />
    </div>
  ) : null;
};

export default OverlaySpinner;
